import classNames from "classnames";
import { IconTranslate as TranslateIcon } from "@icons/index";
import useTitleTranslate from "@hooks/useTitleTranslate";
import { useAppSelector } from "@hooks/redux";
import report from "@report";

const TitleTranslateBtn = ({
  info,
  className: _className,
  onClick,
  hoverable = true,
}: {
  info: any;
  className?: string;
  onClick?: () => void;
  hoverable?: boolean;
}) => {
  const { setShowTranslateModal, setTranslateResourceInfo } = useTitleTranslate();
  const { language } = useAppSelector((state) => state.globalReducer);
  if (language !== "zh-CN" && language !== "en-US") return null;
  return (
    <div
      className={classNames("shrink-0 px-[2px] py-[2px] cursor-pointer rounded-[2px] hover:bg-kds-bg-overlay", {
        "group-hover:visible invisible": hoverable,
      })}
      onClick={(e) => {
        e.stopPropagation();
        setTranslateResourceInfo(info);
        setShowTranslateModal(true);
        onClick?.();
        report.click({
          kalo_type: "translate_title",
          kalo_json: {
            title: info[info.type + "_title"],
            type: info.type,
          },
        });
      }}
    >
      <TranslateIcon className="w-[16px] h-[16px]" />
    </div>
  );
};

export default TitleTranslateBtn;
